/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, FormControlLabel, RadioGroup, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
// import DropZone from '../../Components/DropZone';
// import PageLayout from '../../Components/PageLayout';
// import DatePicker, { DateObject } from "react-multi-date-picker"
// import persian from "react-date-object/calendars/persian"
// import persian_fa from "react-date-object/locales/persian_fa"
// import persian_en from "react-date-object/locales/persian_en";
// import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
// import { ReactComponent as CopyIcon } from "../../Assets/svg/CopyIcon.svg";
// import { ReactComponent as ContactIcon } from "../../Assets/svg/ContactIcon.svg";
import { ReactComponent as PlusIcon } from "../../Assets/svg/PlusIcon.svg";
import { ReactComponent as DangerHome } from "../../Assets/svg/DangerHome.svg";
import { ReactComponent as CloseIcon } from "../../Assets/svg/CloseIcon.svg";
import { ReactComponent as LocationIcon } from "../../Assets/svg/LocationIcon.svg";
import { ReactComponent as NeshanegozariIcon } from "../../Assets/svg/NeshanegozariIcon.svg";
import { ReactComponent as ReportIcon } from "../../Assets/svg/ReportIcon.svg";
import moment from "moment-jalaali"
import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";

// import PropTypes from 'prop-types';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
// import { PropertyContext } from '../../context/property-context';
// import data from '../../api/melkData.json';
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import http from '../../api/axiosInstance';
// import { NumericFormat } from 'react-number-format';
// import {
//     useParams
// } from "react-router-dom";
// import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// import ButtonNavigation from '../../Components/ButtonNavigation';
// import PropItem from '../../Components/PropItem';
import { json, useNavigate } from 'react-router-dom';
import { ReactComponent as PersonIcon } from "../../Assets/svg/PersonIcon.svg";
import { ReactComponent as SettingDarkGray } from "../../Assets/svg/SettingDarkGray.svg";
import { ReactComponent as ArrowRightIconTransparent } from "../../Assets/svg/ArrowRightIconTransparent.svg";
import { ReactComponent as ExitIcon } from "../../Assets/svg/ExitIcon.svg";
// import { useSearchPropStore } from '../../store/searchProperty';
import Radio from '@mui/material/Radio';

import UsersDropZone from '../../Components/UsersDropZone';
import { useUserStore } from '../../store/user';
import ButtonNavigation from '../../Components/ButtonNavigation';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Fade from '@mui/material/Fade';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
import {
    useParams, useLocation
} from "react-router-dom";
import Cookies from 'js-cookie'
import { setUserCookie } from '../../Components/PublicFunctions';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



function FinancialReport(props) {

    const { enqueueSnackbar } = useSnackbar();

    const [openSettingModal, setOpenSettingModal] = useState(false)
    const [openLocalModal, setOpenLocalModal] = useState(false)
    const [openDepositeModal, setOpenDepositeModal] = useState(false)
    const [openUsersModal, setOpenUsersModal] = useState(false)
    const [openAddUser, setOpenAddUser] = useState(false)
    const [deposit, setDeposit] = useState("")
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [Users, setUsers] = React.useState([]);
    const [ofsset, setOfsset] = React.useState(1);
    const [hasMore, setHasMore] = React.useState(true);
    const [UsersLoading, setUsersLoading] = React.useState(false);
    const [propKey, setPropKey] = React.useState(0);
    const [inPlusing, setInPlusing] = React.useState(true);
    const [userImg, setUserImg] = useState(null);
    const [userFullName, setUserFullName] = useState("");
    const [userMobile, setUserMobile] = useState("");
    const [userPass, setUserPass] = useState("");
    const [areaDisplay, setAreaDisplay] = useState(1);
    const [deleteAreaModal, setDeleteAreaModal] = useState(false);
    const [deleteLading, setDeleteLading] = useState(false);
    const [deleteId, setDeleteId] = useState("");
    const [newArea, setNewArea] = useState("");
    const [createAreaLoading, setCreateAreaLoading] = useState(false);
    const [ofssetFlag, setOfssetFlag] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [editAreaModal, setEditAreaModal] = useState(false);
    const [editItem, setEditItem] = useState({});
    const [editLoading, setEditLoading] = useState(false);
    const [financialModal, setFinancialModal] = useState(false);
    const [financialLoading, setFinancialLoading] = useState(false);
    const [financialRows, setFinancialRows] = useState([]);
    const [filterModal, setFilterModal] = useState(false);
    const [filterByDate, setFilterByDate] = useState("");
    const [filterByStatus, setFilterByStatus] = useState("");
    const [costumInputShow, setCostumInputShow] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const [showFromDatePicker, setShowFromDatePicker] = useState(false);
    const [showToDatePicker, setShowToDatePicker] = useState(false);


    const navigate = useNavigate();

    const userInfo = JSON.parse(localStorage.getItem("agency"))

    const dataFetchedRef = useRef(false);

    const accessToken = useUserStore((state) => state.accessToken)
    const locationId = useUserStore((state) => state.locationId)



    const handleClickOpenDepositeModal = () => {
        setOpenDepositeModal(true);
    };
    const handleOpenDepositeModalClose = () => {
        setOpenDepositeModal(false);
    };

    const handleClickOpenAddUserModal = () => {
        setOpenAddUser(true);
    };
    const handleOpenAddUserModalClose = () => {
        setOpenAddUser(false);
    };

    const handleClickFilterModal = () => {
        setFilterModal(true);
    };
    const handleFilterModalClose = () => {
        setFilterModal(false);
    };

    const handleChangeFilterDate = (e) => {
        setFilterByDate(e.target.value);
        if (e.target.value != "costum")
            setCostumInputShow(false)
        else
            setCostumInputShow(true)
        console.log(e.target.value)
    };
    const handleChangeFilterStatus = (e) => {
        setFilterByStatus(e.target.value);

        console.log(e.target.value)
    };


    const handleFinancialModal = async () => {
        getFinancialReports()
        // setFinancialLoading(true)
        setFinancialModal(true);
        // try {
        //     await http({
        //         // url of the api endpoint (can be changed)
        //         url: "/wallet/transactions",
        //         method: "POST",
        //         data: {
        //             "Version": "4.2.2"
        //         },
        //         headers: {
        //             "Authorization": `Bearer ${Cookies.get('token')}`
        //         }
        //     }).then((res) => {

        //         console.log(res);
        //         setFinancialRows(res.data.result.transactions)
        //         setFinancialLoading(false)
        //     });
        // } catch (e) {

        //     console.log("error", e)


        //     setFinancialLoading(false)


        // }

    };
    const handleFinancialModalClose = () => {
        setFinancialModal(false);
    };

    const handleClickOpenDeleteAreaModal = (id) => {
        setDeleteId(id)
        setDeleteAreaModal(true);
    };
    const handleDeleteAreaModalClose = () => {
        setDeleteAreaModal(false);
    };

    const handleClickOpenUsersModal = () => {
        setTimeout(function () {
            if (document && typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("dashboard-content").addEventListener('scroll', onScroll)
                return () => document.getElementById("dashboard-content").removeEventListener('scroll', onScroll)
            }
        }, 500)
        setOpenUsersModal(true);
    };
    const handleOpenUsersModalClose = () => {
        setOpenUsersModal(false);
    };


    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };

    const handleEditAreaModalOpen = (id, name) => {
        setEditItem({
            "Id": id,
            "Name": name,
        })
        setEditAreaModal(true);
    };
    const handleEditAreaModalClose = () => {
        setEditAreaModal(false);
    };

    const handleAddUser = async () => {
        handleToggleBackdrop()

        let formData = new FormData();
        formData.append("BusinessLogo", userImg);
        formData.append('FullName', userFullName)
        formData.append('AgencyMobile', userMobile)
        formData.append('ClientSecret', userPass)
        formData.append('LocationId', locationId)
        formData.append('AppType', "Website")
        formData.append('Version', "4.2.2")

        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/webapp/agencies/create",
                method: "POST",
                data: formData,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {

                console.log(res);
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("کاربر شما با موفقیت ثبت شد.", { variant });
                }

            });
        } catch (e) {

            console.log("error", e.response.data.message)
            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }

        }

        handleCloseBackdrop()
    }



    const handleDeposit = () => {

        if (deposit != "") {
            handleToggleBackdrop()
            try {
                http({
                    url: "/wallet/charge",
                    method: "POST",
                    data: {
                        "Amount": deposit,

                    },
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                }).then((res) => {
                    console.log("checkout_url", res)

                    if (res.data.ok == false) {
                        const variant = 'error'
                        enqueueSnackbar(res.data.message, { variant });
                    } else {
                        window.open(res.data.result.checkout_url, '_blank', 'noreferrer');
                    }

                    handleCloseBackdrop()
                });

            } catch (e) {
                console.error(e);
                if (e.result.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }
                handleCloseBackdrop()


            }
        }
        else {
            const variant = 'error'
            enqueueSnackbar("میبغ را وارد کنید.", { variant });


        }
    };

    const getUsers = (resetState = false) => {
        if (resetState) {
            setUsers([])
            console.log("reset", Users)
            setPropKey(propKey => propKey++)
            setOfsset(0);
            setHasMore(true)
        }

        setUsersLoading(true)
        try {
            http({
                // url of the api endpoint (can be changed)
                url: "/webapp/my_agencies",
                method: "POST",
                data: {
                    "Limit": 10,
                    "Offset": ofsset
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log("users", res.data.result.agencies);

                const tmpProp = [...Users]
                if (res.data.result.agencies.length > 0) {
                    if (!resetState) {
                        res.data.result.agencies.map((item, index) => {
                            tmpProp.push(item)
                        })
                        setUsers(tmpProp)

                        setPropKey(propKey => propKey++)
                    }
                    else
                        setUsers(res.data.result.agencies)


                    setPropKey(propKey => propKey++)

                } else {
                    console.log("End")
                    setHasMore(false)
                    if (resetState) setUsers([])

                }

                console.log("users ff", Users)
                setUsersLoading(false)
                setTimeout(function () { setInPlusing(true) }, 1000)
            });

        } catch (e) {
            console.error(e);
            setUsersLoading(false)

        }


    }


    const onScroll = () => {
        if (document.getElementById("dashboard-content")) {

            const scrollTop = document.getElementById("dashboard-content").scrollTop
            const scrollHeight = document.getElementById("dashboard-content").scrollHeight
            const clientHeight = document.getElementById("dashboard-content").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && inPlusing) {
                setOfsset(ofsset => ofsset + 10);
                // setSearchData({"name":"Offset","value":ofsset})
                console.log("ofsset", ofsset)
                setInPlusing(false)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("dashboard-content").addEventListener('scroll', onScroll)
                return () => document.getElementById("dashboard-content").removeEventListener('scroll', onScroll)
            }
        }, 500)


    }, [Users])

    useEffect(() => {
        console.log("offset use")

        if (hasMore && Users.length) {
            getUsers()
        }
    }, [ofsset])

    function useQuery() {
        return new URLSearchParams(useLocation().search)
    }

    const query = useQuery()
    const token = query.get("token")

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        // getUsers()



        handleToggleBackdrop()




        try {
            http({
                // url of the api endpoint (can be changed)
                url: "/authenticate/get/agency",
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then((res) => {
                console.log("agency", res)

                if (res.data.result) {
                    localStorage.setItem('token', token)
                    setTokenCookie(token)
                    localStorage.setItem('agency', JSON.stringify(res.data.result))
                    setUserCookie(res.data.result)
                    getFinancialReports()
                }
                else {
                    navigate("/login")
                    console.error("error");
                }

                handleCloseBackdrop()

            }).catch((e) => {
                navigate("/login")

                handleCloseBackdrop()
            });
        } catch (e) {


        }
    }, [])


    const handleLogOut = () => {
        localStorage.removeItem("token")
        localStorage.removeItem("provinces")
        localStorage.removeItem("agency")
        navigate("/login")
    }


    //Areas Pagination

    const [areaOfsset, setAreaOfsset] = React.useState(0);
    const [hasMoreOffset, setHasMoreOffset] = React.useState(true);
    const [areasLoading, setAreasLoading] = React.useState(true);
    const [areaInPlusing, setAreaInPlusing] = React.useState(true);
    const [areasItems, setAreasItems] = React.useState([]);

    const areaOnScroll = () => {
        if (document.getElementById("areas-container")) {
            const scrollTop = document.getElementById("areas-container").scrollTop
            const scrollHeight = document.getElementById("areas-container").scrollHeight
            const clientHeight = document.getElementById("areas-container").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && areaInPlusing) {
                setAreaInPlusing(false)
                setAreaOfsset(areaOfsset => areaOfsset + 20);

                // setSearchData({"name":"Offset","value":ofsset})
                console.log("areaOfsset", areaOfsset)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    }, [areasItems])

    // useEffect(() => {
    //   console.log("hasMoreOffset",hasMoreOffset)
    // }, [hasMoreOffset])

    useEffect(() => {
        console.log("offset use sdfsd", areaOfsset)
        console.log("ofssetFlag", ofssetFlag)
        console.log("hasMoreOffset", hasMoreOffset)
        console.log("areasItems.length", areasItems.length)

        if (hasMoreOffset && areasItems.length && !ofssetFlag) {
            console.log("testsr", areaOfsset)
            if (areaDisplay == "1")
                getAreas(false, "", "/webapp/divar_areas/list")
            if (areaDisplay == "2")
                getAreas(false, "", "/areas/list")
        }

        if (ofssetFlag) {
            let url = ""
            if (areaDisplay == "1")
                url = "/webapp/divar_areas/list"
            if (areaDisplay == "2")
                url = "/areas/list"


            const data = {
                "LocationId": locationId,
                "AgencyId": JSON.parse(Cookies.get('agency')).Id,
                "Offset": 0,
                "Limit": 20
            }
            try {
                http({
                    // url of the api endpoint (can be changed)
                    url: url,
                    method: "POST",
                    data: data,
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                }).then((res) => {
                    const tempAreas = [...areasItems]
                    if (res.data.result.items.length > 0) {

                        setAreasItems(res.data.result.items)

                        console.log("areasItems", areasItems)


                    } else {
                        console.log("End")
                        setHasMoreOffset(false)


                    }
                    setTimeout(function () { setAreaInPlusing(true) }, 3000)
                    setOfssetFlag(false)
                    setAreasLoading(false)


                });
            } catch (e) {
                console.error(e);
                setAreasLoading(false)
            }

        }


    }, [areaOfsset])

    useEffect(() => {
        console.log("offset use sdfsd", areaOfsset)
        console.log("ofssetFlag", ofssetFlag)


        if (ofssetFlag) {
            setAreasItems([])
            setAreaOfsset(0);
            setHasMoreOffset(true)

            let url = ""
            if (areaDisplay == "1")
                url = "/webapp/divar_areas/list"
            if (areaDisplay == "2")
                url = "/areas/list"


            const data = {
                "LocationId": locationId,
                "AgencyId": JSON.parse(Cookies.get('agency')).Id,
                "Offset": 0,
                "Limit": 20
            }
            try {
                http({
                    // url of the api endpoint (can be changed)
                    url: url,
                    method: "POST",
                    data: data,
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                }).then((res) => {
                    const tempAreas = [...areasItems]
                    if (res.data.result.items.length > 0) {

                        setAreasItems(res.data.result.items)

                        console.log("areasItems", areasItems)


                    } else {
                        if (isDelete) {
                            setAreasItems(res.data.result.items)
                            setIsDelete(false)
                        } else {
                            console.log("End")
                            setHasMoreOffset(false)

                        }


                    }
                    setTimeout(function () { setAreaInPlusing(true) }, 3000)
                    setOfssetFlag(false)
                    setAreasLoading(false)


                });
            } catch (e) {
                console.error(e);
                setAreasLoading(false)
            }

        }


    }, [ofssetFlag])



    const getAreas = (resetState = false, name = "", url = "/areas/list") => {
        if (resetState) {
            setAreasItems([])
            setAreaOfsset(0);
            setHasMoreOffset(true)
            console.log("offse", areaOfsset)
        }


        setAreasLoading(true)


        const data = {
            "LocationId": Cookies.get('locationId'),

            "AgencyId": JSON.parse(Cookies.get('agency')).Id,
            "Offset": areaOfsset,
            "Limit": 20
        }

        console.log("data", data)

        if (name != "") data["Name"] = name

        try {
            http({
                // url of the api endpoint (can be changed)
                url: url,
                method: "POST",
                data: data,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                const tempAreas = [...areasItems]
                if (res.data.result.items.length > 0) {
                    if (!resetState) {
                        res.data.result.items.map((item, index) => {
                            tempAreas.push(item)
                        })
                        setAreasItems(tempAreas)
                        console.log("resetState not")
                    }
                    else
                        setAreasItems(res.data.result.items)

                    console.log("areasItems", areasItems)


                } else {
                    console.log("End")
                    setHasMoreOffset(false)
                    if (resetState) setAreasItems([])

                }
                setTimeout(function () { setAreaInPlusing(true) }, 3000)
                setAreasLoading(false)


            });
        } catch (e) {
            console.error(e);
            setAreasLoading(false)
        }
    }

    useEffect(() => {
        console.log("areaDisplay", areaDisplay)
        // setAreaOfsset(0)
        setOfssetFlag(true)
        // if (areaDisplay == "1")
        //     getAreas(true, "", "/webapp/divar_areas/list")
        // if (areaDisplay == "2")
        //     getAreas(true, "", "/areas/list")

    }, [areaDisplay])
    ///////////////////////

    const deleteArea = () => {
        console.log("deleteId", deleteId)
        console.log("token", Cookies.get('token'))

        setDeleteLading(true)
        try {
            http({
                url: "/areas/delete",
                method: "POST",
                data: {
                    "Id": parseInt(deleteId)
                },
                headers: {

                    "Authorization": `Bearer ${Cookies.get('token')}`

                }
            }).then((res) => {
                console.log(res)
                setOfssetFlag(true)
                setIsDelete(true)
                setAreaOfsset(0);
                setDeleteId("")
                handleDeleteAreaModalClose()
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("محمدوده مورد نظر با موفقیت حذف شد.", { variant });
                }
                setDeleteLading(false)


            });
        } catch (e) {
            console.error(e);
            setDeleteLading(false)

        }
    }

    const createArea = () => {
        console.log("newArea", newArea)

        setCreateAreaLoading(true)
        try {
            http({
                url: "/areas/create",
                method: "POST",
                data: {
                    "Name": newArea,
                    "LocationId": locationId
                },
                headers: {

                    "Authorization": `Bearer ${Cookies.get('token')}`

                }
            }).then((res) => {
                console.log(res)
                setOfssetFlag(true)

                setAreaOfsset(0);

                setNewArea("")
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("محمدوده با موفقیت اضافه شد.", { variant });
                }
                setCreateAreaLoading(false)

                // setTimeout(function () { getAreas(true, "", "/areas/list") }, 500)

            });
        } catch (e) {
            console.error(e);
            setCreateAreaLoading(false)

        }
    }

    const handleChangeEditItems = (name) => {
        let tmp = { ...editItem }
        tmp.Name = name
        setEditItem(tmp)
    }

    const handleEdit = () => {
        handleToggleBackdrop()


        try {
            http({
                url: "/areas/update",
                method: "POST",
                data: {
                    ...editItem,
                    LocationId: locationId
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log(res)
                setOfssetFlag(true)

                setAreaOfsset(0);
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("محمدوده با موفقیت ویرایش شد.", { variant });
                }
                handleEditAreaModalClose()
                handleCloseBackdrop()
            });
        } catch (e) {
            console.error(e);
            handleCloseBackdrop()
        }
    }


    //financial Pagination
    const [FinancialOffset, setFinancialOffset] = React.useState(0);
    const [HasMoreFinancial, setHasMoreFinancial] = React.useState(true);
    const [FinancialInPlusing, setFinancialInPlusing] = React.useState(true);
    const [FinancialReport, setFinancialReport] = React.useState([]);
    const [FinancialOffsetFlag, setFinancialOffsetFlag] = useState(false);

    const FinancialReportOnScroll = () => {
        if (document.getElementById("FinancialReports-container")) {
            const scrollTop = document.getElementById("FinancialReports-container").scrollTop
            const scrollHeight = document.getElementById("FinancialReports-container").scrollHeight
            const clientHeight = document.getElementById("FinancialReports-container").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && FinancialInPlusing) {
                setFinancialInPlusing(false)
                setFinancialOffset(FinancialOffset => FinancialOffset + 1);

                // setSearchData({"name":"Offset","value":ofsset})
                console.log("FinancialOffset", FinancialOffset)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("FinancialReports-container") !== 'undefined' && document.getElementById("FinancialReports-container") !== null && FinancialReport.length > 0) {
                document.getElementById("FinancialReports-container").addEventListener('scroll', FinancialReportOnScroll)
                return () => document.getElementById("FinancialReports-container").removeEventListener('scroll', FinancialReportOnScroll)
            }
        }, 500)
    }, [FinancialReport])

    // useEffect(() => {
    //   console.log("HasMoreFinancial",HasMoreFinancial)
    // }, [HasMoreFinancial])

    useEffect(() => {
        console.log("offset use sdfsd", FinancialOffset)
        console.log("FinancialOffsetFlag", FinancialOffsetFlag)
        console.log("HasMoreFinancial", HasMoreFinancial)
        console.log("FinancialReport.length", FinancialReport.length)

        if (HasMoreFinancial && FinancialReport.length && !FinancialOffsetFlag) {
            console.log("testsr", FinancialOffset)

            getFinancialReports(false, "")

        }




    }, [FinancialOffset])

    useEffect(() => {
        console.log("FinancialOffset change to 0", FinancialOffset)
        console.log("FinancialOffsetFlag", FinancialOffsetFlag)


        if (FinancialOffsetFlag) {
            setFinancialReport([])
            // setFinancialOffset(0);
            setHasMoreFinancial(true)

            setFinancialLoading(true)
            let url = "/wallet/transactions"


            const data = {
                // "LocationId": locationId,
                // "AgencyId": JSON.parse(Cookies.get('agency')).Id,
                "Version": "4.2.2",
                "Offset": 0,
                "Limit": 20
            }
            if (filterByDate != "") {
                console.log("filterSet")
                if (filterByDate == "today") {
                    let date = new Date();
                    data["From"] = +date
                }
                if (filterByDate == "30") {
                    let today = new Date();
                    let priorDate = new Date(new Date().setDate(today.getDate() - 30));
                    data["From"] = +priorDate
                }
                if (filterByDate == "7") {
                    let today = new Date();
                    let priorDate = new Date(new Date().setDate(today.getDate() - 7));
                    data["From"] = +priorDate
                }
                if (filterByDate == "costum") {
                    data["From"] = fromDate
                    data["To"] = toDate
                }
            }

            if (filterByStatus != "") {
                console.log("filterSet")
                data["Status"] = filterByStatus
            }
            try {
                http({
                    // url of the api endpoint (can be changed)
                    url: url,
                    method: "POST",
                    data: data,
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                }).then((res) => {
                    const tempFinancialReports = [...FinancialReport]
                    if (res.data.result.transactions.length > 0) {

                        setFinancialReport(res.data.result.transactions)

                        console.log("FinancialReport", FinancialReport)


                    } else {
                        console.log("End")
                        setHasMoreFinancial(false)
                        // if (resetState) setFinancialReport([])

                    }
                    setTimeout(function () { setFinancialInPlusing(true) }, 3000)
                    setFinancialOffsetFlag(false)
                    setFinancialLoading(false)


                });
            } catch (e) {
                console.error(e);
                setFinancialLoading(false)
            }


        }


    }, [FinancialOffsetFlag])



    const getFinancialReports = (resetState = false, name = "", url = "/wallet/transactions") => {
        if (resetState) {
            setFinancialReport([])
            setFinancialOffset(0);
            setHasMoreFinancial(true)
            console.log("offse", FinancialOffset)
        }


        setFinancialLoading(true)


        const data = {
            // "LocationId": locationId,
            // "AgencyId": JSON.parse(Cookies.get('agency')).Id,
            "Version": "4.2.2",
            "Offset": FinancialOffset,
            "Limit": 20
        }

        console.log("data", data)

        if (filterByDate != "") {
            console.log("filterSet")
            if (filterByDate == "today") {
                let date = new Date();
                data["From"] = +date
            }
            if (filterByDate == "30") {
                let today = new Date();
                let priorDate = new Date(new Date().setDate(today.getDate() - 30));
                data["From"] = +priorDate
            }
            if (filterByDate == "7") {
                let today = new Date();
                let priorDate = new Date(new Date().setDate(today.getDate() - 7));
                data["From"] = +priorDate
            }
            if (filterByDate == "costum") {
                data["From"] = fromDate
                data["To"] = toDate
            }
        }

        if (filterByStatus != "") {
            console.log("filterSet")
            data["Status"] = filterByStatus
        }

        try {
            http({
                // url of the api endpoint (can be changed)
                url: url,
                method: "POST",
                data: data,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                const tempFinancialReports = [...FinancialReport]
                if (res.data.result.transactions.length > 0) {
                    if (!resetState) {
                        res.data.result.transactions.map((item, index) => {
                            tempFinancialReports.push(item)
                        })
                        setFinancialReport(tempFinancialReports)
                        console.log("resetState not")
                    }
                    else
                        setFinancialReport(res.data.result.transactions)

                    console.log("FinancialReport", FinancialReport)


                } else {
                    console.log("End")
                    setHasMoreFinancial(false)
                    if (resetState) setFinancialReport([])

                }
                setTimeout(function () { setFinancialInPlusing(true) }, 3000)
                setFinancialLoading(false)


            });
        } catch (e) {
            console.error(e);
            setFinancialLoading(false)

        }
    }

    // useEffect(() => {
    //     // console.log("FinancialReportDisplay", FinancialReportDisplay)
    //     // setFinancialOffset(0)
    //     setFinancialOffsetFlag(true)
    //     // if (FinancialReportDisplay == "1")
    //     //     getFinancialReports(true, "", "/webapp/divar_FinancialReports/list")
    //     // if (FinancialReportDisplay == "2")
    //     //     getFinancialReports(true, "", "/FinancialReports/list")

    // }, [FinancialReportDisplay])

    ///////////////////////

    const handleSetFilter = () => {
        // getFinancialReports(true)
        console.log("filterByDate", filterByDate)
        setFinancialReport([])
        setFinancialOffsetFlag(true)
        handleFilterModalClose()
    }



    const handleSetfromDate = (selectedDate) => {
        console.log(+selectedDate.date)
        setFromDate(+selectedDate.date)
    }
    const handleSetToDate = (selectedDate) => {
        
        console.log(+selectedDate.date)
        setToDate(+selectedDate.date)
    }

    const formatJalali = (timestamp) => {
        console.log("timestamp", timestamp)
        try {
            return timestamp ? moment.unix(parseInt(timestamp / 1000)).format("jYYYY/jMM/jDD") : timestamp
        } catch (e) {
            console.log("error", e)
            return timestamp;
        }
    }

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: 99999 }}
                open={openBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <AppBar sx={{ position: 'relative', bgcolor: '#fff', color: '#666666' }}>
                <Toolbar>

                    {/* <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleFinancialModalClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton> */}
                    <Typography sx={{ ml: 'auto', mr: 2, fontSize: "15px" }} variant="h6" component="div">
                        گزارشات مالی
                    </Typography>
                    <Button autoFocus className='green-btn' color="inherit" sx={{ fontSize: "12px" }} onClick={handleClickOpenDepositeModal}>
                        افزایش اعتبار
                    </Button>

                </Toolbar>
            </AppBar>
            <Box sx={{ mt: 2, color: '#8F8F8F', pb: 3 }}>

                <Box>
                    <Box sx={{ p: 2, color: '#8F8F8F', height: "calc(100vh - 135px)!important", overflow: 'auto' }} id="FinancialReports-container">
                        <Box sx={{ display: "flex", gap: "5px", mb: 2 }}>
                            <Box>موجودی : </Box>
                            <Box sx={{ display: "flex", gap: "5px" }}>
                                <Typography variant='span'>{JSON.parse(Cookies.get('agency')).Credit}</Typography>
                                <Typography variant='span'>تومان</Typography>
                            </Box>
                        </Box>
                        <Button sx={{ display: "flex", gap: "5px", alignItems: "center", bgcolor: "#ECE9E9", color: "#8F8F8F", mb: 2 }} onClick={handleClickFilterModal}>
                            <img src='/assets/img/filterIcon.png' />
                            فیلتر ها
                        </Button>
                        <TableContainer component={Paper} sx={{ position: "relative" }}>
                            <Table sx={{ minWidth: 650, textAlign: "center" }} className='financial-table' aria-label="simple table">
                                <TableHead >
                                    <TableRow>
                                        <TableCell align="right">#</TableCell>

                                        <TableCell>مبلغ</TableCell>
                                        <TableCell align="right">وضعیت</TableCell>
                                        <TableCell align="right">نوع</TableCell>
                                        <TableCell align="right">تاریخ تراکنش</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {FinancialReport && FinancialReport.length > 0 ? FinancialReport.map((row) => (
                                        <TableRow
                                            key={row.trans_id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {row.trans_id}
                                            </TableCell>
                                            <TableCell align="right">{row.trans_amount}</TableCell>

                                            <TableCell align="right">
                                                {row.trans_type == "1" ? "سفارش سایت اختصاصی" : null}
                                                {row.trans_type == "2" ? "خرید افزونه" : null}
                                                {row.trans_type == "3" ? "افزایش اعتبار" : null}
                                                {row.trans_type == "4" ? "شارژ سامانه پیامک" : null}
                                                {row.trans_type == "5" ? "واریزی ها" : null}
                                                {row.trans_type == "6" ? "خرید فایل" : null}
                                            </TableCell>
                                            <TableCell align="right" sx={{ color: row.status == "0" ? "#f76708" : "green" }}>
                                                {row.status == "0" ? "پرداخت نشده" : null}
                                                {row.status == "1" ? "پرداخت شده" : null}

                                            </TableCell>
                                            <TableCell align="right">{moment.unix(row.trans_date).format("jYYYY/jMM/jDD")}</TableCell>
                                        </TableRow>

                                    )) : !financialLoading && <Box sx={{ py: 2 }}>
                                        موردی یافت نشد!
                                    </Box>}
                                    {
                                        financialLoading ? <Box sx={{ textAlign: 'center', width: "100%", p: 2 }}>درحال بارگیری...</Box> : ""

                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            </Box>


            {filterModal && <Dialog className="dialog-box"
                fullScreen
                open={filterModal}
                onClose={handleFilterModalClose}
                TransitionComponent={Transition}

            >
                <AppBar sx={{ position: 'relative', bgcolor: '#fff', color: '#666666' }}>
                    <Toolbar>


                        <Typography sx={{ ml: 'auto', mr: 2, fontSize: "15px" }} variant="h6" component="div">
                            فیلتر ها
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleFilterModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>

                    </Toolbar>
                </AppBar>
                <Box sx={{ mt: 2, color: '#8F8F8F', px: 2, pb: 3 }}>
                    <Box>
                        <label className=' text-label'>وضعیت</label>
                        <Box className="inputs-container" sx={{ width: 'auto', p: 1, display: "flex", alignItems: "center", mt: 1 }}>
                            <select
                                labelid="demo-simple-select-label"
                                id="demo-simple-select"
                                value={filterByStatus}
                                onInput={handleChangeFilterStatus}
                                className="select-control"
                            >
                                <option selected value="">هیچکدام</option>
                                <option selected value="1">سفارش سایت اختصاصی</option>
                                <option value="2">خرید افزونه</option>
                                <option value="3">افزایش اعتبار</option>
                                <option value="4">شارژ سامانه پیامک</option>
                                <option value="5">واریزی ها</option>
                                <option value="6">خرید فایل</option>
                            </select>
                        </Box>
                    </Box>
                    <Box sx={{ mt: 2 }}>
                        <label className=' text-label'>بر اساس تاریخ</label>
                        <Box className="inputs-container" sx={{ width: 'auto', p: 1, display: "flex", alignItems: "center", mt: 1 }}>
                            <select
                                labelid="demo-simple-select-label"
                                id="demo-simple-select"
                                value={filterByDate}
                                onInput={handleChangeFilterDate}
                                className="select-control"
                            >
                                <option selected value="">هیچکدام</option>
                                <option value="today">امروز</option>
                                <option value="7">7 روز گذشته</option>
                                <option value="30">30 روز گذشته</option>
                                <option value="costum">بازه دلخواه</option>
                            </select>
                        </Box>
                    </Box>
                    <Fade in={costumInputShow}>
                        <Box sx={{ mt: 2 }}>
                            <label className=' text-label'>بازه دلخواه</label>

                            <Grid container className="inputs-container" sx={{ mt: 1 }}>
                                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <div className='flex-1 w-chile-100'>
                                        {/* <DatePicker calendar={persian} placeholder="تاریخ ثبت"
                                            locale={persian_fa} onChange={handleSetfromDate} /> */}
                                        <InputBase value={formatJalali(fromDate)} className='flex-1' onClick={() => setShowFromDatePicker(true)}  placeholder="تاریخ ثبت" />
                                        <Picker
                                            isOpen={showFromDatePicker}
                                            config={config}
                                            initialValue={new Date(fromDate ? new Date(fromDate) : new Date())}
                                            minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                            maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                            onSubmit={handleSetfromDate}
                                            // onChange={handleSetfromDate}
                                            onClose={() => setShowFromDatePicker(false)}
                                            highlightWeekends
                                        />
                                    </div>
                                    <CalendarIcon />
                                </Grid>
                                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <div className='flex-1 w-chile-100'>
                                        {/* <DatePicker onChange={handleSetToDate} calendar={persian} placeholder="تاریخ بازیابی"
                                            locale={persian_fa} /> */}
                                        <InputBase value={formatJalali(toDate)} className='flex-1' onClick={() => setShowToDatePicker(true)} placeholder="تاریخ بازیابی"/>
                                        <Picker
                                            isOpen={showToDatePicker}
                                            config={config}
                                            initialValue={new Date(toDate ? new Date(toDate) : new Date())}
                                            minDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 1, day: 1 })}
                                            maxDate={newDate({ year: parseInt(moment().format("jYYYY")) +10, month: 12, day: 29 })}
                                            onSubmit={handleSetToDate}
                                            // onChange={handleSetToDate}
                                            onClose={() => setShowToDatePicker(false)}
                                            highlightWeekends
                                        />
                                    </div>

                                    <CalendarIcon />

                                </Grid>
                            </Grid>
                        </Box>
                    </Fade>
                </Box>
                <Button className='green-btn' onClick={handleSetFilter} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog >}
        </>
    );
}

export default FinancialReport;